import DmnModdle from 'dmn-moddle';

export class DmnWriter {
  constructor() {
    this._moddleExtensions = {};
    this._moddle = null;
  }

  addModdleExtension(name, descriptor) {
    this._moddleExtensions[name] = descriptor;
    this._moddle = null;
  }

  _getModdle() {
    if (!this._moddle) {
      this._moddle = DmnModdle(this._moddleExtensions);
    }
    return this._moddle;
  }

  getModdle() {
    return this._getModdle();
  }

  async write(definitions, options = {}) {
    if (!definitions || definitions.$type !== 'dmn:Definitions') {
      throw new Error('[DmnWriter] definitions (dmn:Definitions) is required');
    }
    const moddle = this._getModdle();
    const { xml } = await moddle.toXML(definitions, {
      format: options.format !== false,
      preamble: options.preamble !== false,
    });
    return { xml, warnings: [] };
  }
}
